import { Component } from '@angular/core';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import {
  Quals, QualTasks, QualXQualTasks, QualTaskXPrerequisites, QualXJobTitles, QualXJobAssignments, QualXAssigned,
  Trainers, QualTaskXTrainers
} from '../training/trainingCommon';
import { AimsCommonPopupEditorComponent, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { Validators } from '@angular/forms';
import { AIMS_NUMERIC_TYPES } from 'src/app/components/aims-numeric/aims-numeric.component';
import { MatDialog } from '@angular/material/dialog';
import { NewQualQualTaskDialogComponent } from './new-qual-qual-task-dialog/new-qual-qual-task-dialog.component';
import { NewQualJobTitleDialogComponent } from './new-qual-job-title-dialog/new-qual-job-title-dialog.component';
import { NewQualJobAssignmentDialogComponent } from './new-qual-job-assignment-dialog/new-qual-job-assignment-dialog.component';
import { NewQualTaskQualDialogComponent } from './new-qual-task-qual-dialog/new-qual-task-qual-dialog.component';
import { NewQualTaskPrerequisiteDialogComponent } from './new-qual-task-prerequisite-dialog/new-qual-task-prerequisite-dialog.component';
import { NewQualTaskTrainerDialogComponent } from './new-qual-task-trainer-dialog/new-qual-task-trainer-dialog.component';
import { NewTrainerQualTaskDialogComponent } from './new-trainer-qual-task-dialog/new-trainer-qual-task-dialog.component';
import { NewReqQualForEmpDialogComponent } from './new-req-qual-for-emp-dialog/new-req-qual-for-emp-dialog.component';
import { NewReqQualForMultipleEmpsDialogComponent } from './new-req-qual-for-multiple-emps-dialog/new-req-qual-for-multiple-emps-dialog.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'trainingConfig',
  templateUrl: './trainingConfig.component.html',
  providers: []
})

export class TrainingConfigComponent {

  constructor(private transferHttp: TransferHttpService,
    public permissions: PermissionsService,
    public dialog: MatDialog) { }

  // Quals Table
  qualsTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig, {
      delete: false,
    });

  qualsTableHeader: AimsCommonTableHeader[] = [
    { key: 'rowExpand', label: '', type: 'rowExpand', filter: false },
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualDesc', label: 'Description', type: 'string', validatorOrOpts: [Validators.required]},
    { key: 'qualOwnerId', label: 'Qual Owner', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualOwnerId } },
    { key: 'requiredByAllEmps', label: 'Required By All Employees?', type: 'boolean', filterType: 'boolean', width: 100},
    { key: 'active', label: 'Active', type: 'boolean', filterType: 'boolean', width: 100},
  ];
  defaultQual: Quals = this.newTrQual();

  handleQualRowUpdate(update: TableRowUpdate): void {
    let item: Quals = update.newRow as Quals;
    this.transferHttp.put('Tr/SaveQual', item).subscribe(_ => {
      this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
    });
  }

 // Qual x Task sub table
  qualQualTasksTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig, {
      create: false,
    });
  qualsQualTasksTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualTaskId', label: 'Qualification Task', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualTaskId } },
  ];
  defaultQualQualTask: QualXQualTasks = this.newTrQualQualTask();

  handleQualQualTaskRowUpdate(update: TableRowUpdate): void {
    let item: QualXQualTasks = update.newRow as QualXQualTasks ;
    this.transferHttp.put('Tr/SaveQualQualTask', item).subscribe(_ => {
      this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
    });
  }

  handleQualQualTaskRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualXQualTasks = deleted.row as QualXQualTasks;
    this.transferHttp.delete(`Tr/DeleteQualQualTask?qualQualTaskId=${deletedLineItem.qualQualTaskId}`).subscribe(_ => {
      this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
    });
  }

  // Qual Req For Emp sub table
  reqQualForEmpTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig, {
      create: false,
    });
  reqQualForEmpTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualId', label: 'Qualification', type: 'dynamic', validatorOrOpts: [Validators.required], filter: false },
    { key: 'employeeId', label: 'Employee', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.employeeId} },
  ];
  defaultReqQualForEmp: QualXAssigned = this.newTrReqQualForEmp();

  handleReqQualForEmpRowUpdate(update: TableRowUpdate): void {
    let item: QualXAssigned = update.newRow as QualXAssigned ;
    this.transferHttp.put('Tr/SaveReqQualForEmp', item).subscribe(_ => {
      this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
    });
  }

  handleReqQualForEmpRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualXAssigned = deleted.row as QualXAssigned;
    this.transferHttp.delete(`Tr/DeleteReqQualForEmp?qualAssignedId=${deletedLineItem.qualAssignedId}`).subscribe(_ => {
      this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
    });
  }

  // Qual Req For Job sub table
  reqQualForJobTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig, {
      create: false,
    });
  reqQualForJobTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'jobTitleId', label: 'Job Title', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.jobTitleId} },
  ];
  defaultReqQualForJob: QualXJobTitles = this.newTrReqQualForJobTitle();

  handleReqQualForJobRowUpdate(update: TableRowUpdate): void {
    let item: QualXJobTitles = update.newRow as QualXJobTitles ;
    this.transferHttp.put('Tr/SaveReqQualForJobTitle', item).subscribe(_ => {
      this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
    });
  }

  handleReqQualForJobRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualXJobTitles = deleted.row as QualXJobTitles;
    this.transferHttp.delete(`Tr/DeleteReqQualForJobTitle?qualJobTitleId=${deletedLineItem.qualJobTitleId}`).subscribe(_ => {
      this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
    });
  }

  // Qual Req For Job Assignment sub table
  reqQualForJobAssignmentTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig, {
      create: false,
    });
  reqQualForJobAssignmentTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'employeeJobAssignmentId', label: 'Job Assignment - Job Title', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.employeeJobAssignmentId} },
  ];
  defaultReqQualForJobAssignment: QualXJobAssignments = this.newTrReqQualForJobAssignment();

  handleReqQualForJobAssignmentRowUpdate(update: TableRowUpdate): void {
    let item: QualXJobAssignments = update.newRow as QualXJobAssignments ;
    this.transferHttp.put('Tr/SaveReqQualForJobAssignment', item).subscribe(_ => {
      this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
    });
  }

  handleReqQualForJobAssignmentRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualXJobAssignments = deleted.row as QualXJobAssignments;
    this.transferHttp.delete(`Tr/DeleteReqQualForJobAssignment?qualJobAssignmentId=${deletedLineItem.qualJobAssignmentId}`).subscribe(_ => {
      this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
    });
  }

  // Qual Tasks Table
  qualTasksTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig, {
      delete: false,
    });
  qualTasksTableHeader: AimsCommonTableHeader[] = [
    { key: 'rowExpand', label: '', type: 'rowExpand', filter: false },
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qtDesc', label: 'Description', type: 'string', validatorOrOpts: [Validators.required], width: 160},
    { key: 'qualTaskWsOwnerId', label: 'Work Section Owner', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualTaskWsOwnerId } },
    { key: 'intervalInMonths', label: 'Interval In Months', type: 'number', validatorOrOpts: [Validators.min(0)]},
    { key: 'hazwoper', label: 'HAZWOPER', type: 'boolean', filterType: 'boolean', width: 90},
    { key: 'note', label: 'Note', type: 'string', width: 120 },
    { key: 'active', label: 'Active', type: 'boolean', filterType: 'boolean', width: 90},
    { key: 'qualTaskUrlLink', label: 'Course/Training URL', type: 'string', width: 220, validatorOrOpts: [Validators.maxLength(250)]},
    { key: 'goToQualTaskUrlLink', label: 'Training Link', type: 'dynamic', },
  ];
  defaultQualTask: QualTasks = this.newTrQualTask();

  handleQualTaskRowUpdate(update: TableRowUpdate): void {
    let item: QualTasks = update.newRow as QualTasks ;
    this.transferHttp.put('Tr/SaveQualTask', item).subscribe(_ => {
      this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
    });
  }

  qualTasksToQualTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig, {
      create: false,
    });
  qualTasksToQualTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualId', label: 'Qualification', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualId } },
  ];

  // Qual Tasks x Prerequisite Tasks
  qualTasksToPrequisiteQualTaskTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig, {
      create: false,
    });
  qualTasksToPrequisiteQualTaskTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'preReqQualTaskId', label: 'Prerequisite', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.preReqQualTaskId} },
  ];
  defaultQualTaskPrerequisite: QualTaskXPrerequisites = new QualTaskXPrerequisites();;

  handleQualTaskPreqequisiteRowUpdate(update: TableRowUpdate): void {
    let item: QualTaskXPrerequisites = update.newRow as QualTaskXPrerequisites;
    this.transferHttp.put('Tr/SaveQualTaskPrerequisite', item).subscribe(_ => {
      this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
    });
  }

  handleQualTaskPreqequisiteRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualTaskXPrerequisites = deleted.row as QualTaskXPrerequisites;
    this.transferHttp.delete(`Tr/DeleteQualTaskPrerequisite?qualTaskPreReqId=${deletedLineItem.qualTaskPreReqId}`).subscribe(_ => {
      this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
    });
  }

  // Qual Task Trainers
  qualTasksTrainerTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig, {
      create: false,
    });
  qualTasksTrainerTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'trainerId', label: 'Employee', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.trainerId} },
  ];
  defaultQualTaskTrainer: QualTaskXTrainers = new QualTaskXTrainers();;

  handleQualTaskTrainerRowUpdate(update: TableRowUpdate): void {
    let item: QualTaskXTrainers = update.newRow as QualTaskXTrainers;
    this.transferHttp.put('Tr/SaveQualTaskTrainer', item).subscribe(_ => {
      this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
    });
  }

  handleQualTaskTrainerRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualTaskXTrainers = deleted.row as QualTaskXTrainers;
    this.transferHttp.delete(`Tr/DeleteQualTaskTrainer?qualTaskTrainerId=${deletedLineItem.qualTaskTrainerId}`).subscribe(_ => {
      this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
    });
  }

  // Qual to Qual Task Crossover
  qualXQualTasksTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig);

  qualXQualTasksTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualId', label: 'Qualification', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualId } },
    { key: 'qualTaskId', label: 'Qualification Task', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualTaskId } },
  ];
  defaultQualXQualTask: QualXQualTasks = new QualXQualTasks();;

  handleQualXQualTaskRowUpdate(update: TableRowUpdate): void {
    let item: QualXQualTasks = update.newRow as QualXQualTasks;
    this.transferHttp.put('Tr/SaveQualQualTask', item).subscribe(_ => {
      this.qualQualTasks = this.transferHttp.getHot(`Tr/GetQualQualTasks`);
    });
  }

  handleQualXQualTaskRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualXQualTasks= deleted.row as QualXQualTasks;
    this.transferHttp.delete(`Tr/DeleteQualQualTask?qualQualTaskId=${deletedLineItem.qualQualTaskId}`).subscribe(_ => {
      this.qualQualTasks = this.transferHttp.getHot(`Tr/GetQualQualTasks`);
    });
  }

  // Qual Task To Prerequisite
  qualTasksXPrereqTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig);
  qualTasksXPrereqTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualTaskId', label: 'Qualification Task', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualTaskId } },
    { key: 'preReqQualTaskId', label: 'Prerequisite', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.preReqQualTaskId} },
  ];
  defaultQualTaskXPrereq: QualTaskXPrerequisites = new QualTaskXPrerequisites();;

  handleQualTaskXPrereqRowUpdate(update: TableRowUpdate): void {
    let item: QualTaskXPrerequisites = update.newRow as QualTaskXPrerequisites;
    this.transferHttp.put('Tr/SaveQualTaskPrerequisite', item).subscribe(_ => {
      this.qualTaskPrerequisites = this.transferHttp.getHot(`Tr/GetQualTaskPrerequisites`);
    });
  }

  handleQualTaskXPrereqRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualTaskXPrerequisites = deleted.row as QualTaskXPrerequisites;
    this.transferHttp.delete(`Tr/DeleteQualTaskPrerequisite?qualTaskPreReqId=${deletedLineItem.qualTaskPreReqId}`).subscribe(_ => {
      this.qualTaskPrerequisites = this.transferHttp.getHot(`Tr/GetQualTaskPrerequisites`);
    });
  }

  // Qual To Employee
  qualXAssignedTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig);
  qualXAssignedTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualId', label: 'Qualification', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualId } },
    { key: 'employeeId', label: 'Employee', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.employeeId} },
  ];
  defaultQualXAssigned: QualXAssigned = new QualXAssigned();

  handleQualXAssignedRowUpdate(update: TableRowUpdate): void {
    let item: QualXAssigned = update.newRow as QualXAssigned;
    this.transferHttp.put('Tr/SaveReqQualForEmp', item).subscribe(_ => {
      this.reqQualsForEmps = this.transferHttp.getHot(`Tr/GetReqQualsForEmps`);
    });
  }

  handleQualXAssignedRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualXAssigned = deleted.row as QualXAssigned;
    this.transferHttp.delete(`Tr/DeleteReqQualForEmp?qualAssignedId=${deletedLineItem.qualAssignedId}`).subscribe(_ => {
      this.reqQualsForEmps = this.transferHttp.getHot(`Tr/GetReqQualsForEmps`);
    });
  }

  // Qual To Job Title
  qualXJobTitleTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig);
  qualXJobTitleTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualId', label: 'Qualification', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualId } },
    { key: 'jobTitleId', label: 'Job Title', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.jobTitleId } },
  ];
  defaultQualXJobTitles: QualXJobTitles = new QualXJobTitles();

  handleQualXJobTitleRowUpdate(update: TableRowUpdate): void {
    let item: QualXJobTitles = update.newRow as QualXJobTitles;
    this.transferHttp.put('Tr/SaveReqQualForJobTitle', item).subscribe(_ => {
      this.reqQualsForJobTitles = this.transferHttp.getHot(`Tr/GetReqQualsForJobTitles`);
    });
  }

  handleQualXJobTitleRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualXJobTitles = deleted.row as QualXJobTitles;
    this.transferHttp.delete(`Tr/DeleteReqQualForJobTitle?qualJobTitleId=${deletedLineItem.qualJobTitleId}`).subscribe(_ => {
      this.reqQualsForJobTitles = this.transferHttp.getHot(`Tr/GetReqQualsForJobTitles`);
    });
  }

  // Qual To Job Assignment
  qualXJobAssignmentTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig);
  qualXJobAssignmentTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualId', label: 'Qualification', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualId } },
    { key: 'employeeJobAssignmentId', label: 'Job Assignment - Job Title', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.employeeJobAssignmentId } },
  ];
  defaultQualXJobAssignments: QualXJobAssignments = new QualXJobAssignments();

  handleQualXJobAssignmentRowUpdate(update: TableRowUpdate): void {
    let item: QualXJobAssignments = update.newRow as QualXJobAssignments;
    this.transferHttp.put('Tr/SaveReqQualForJobAssignment', item).subscribe(_ => {
      this.reqQualsForJobAssignments = this.transferHttp.getHot(`Tr/GetReqQualsForJobAssignments`);
    });
  }

  handleQualXJobAssignmentRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualXJobAssignments = deleted.row as QualXJobAssignments;
    this.transferHttp.delete(`Tr/DeleteReqQualForJobAssignment?qualJobAssignmentId=${deletedLineItem.qualJobAssignmentId}`).subscribe(_ => {
      this.reqQualsForJobAssignments = this.transferHttp.getHot(`Tr/GetReqQualsForJobAssignments`);
    });
  }

  // Trainers
  trainerTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig);
  trainerTableHeader: AimsCommonTableHeader[] = [
    { key: 'rowExpand', label: '', type: 'rowExpand', filter: false },
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'employeeId', label: 'Employee', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.employeeId } },
    { key: 'active', label: 'Active ?', type: 'boolean',  filterType: 'boolean', width: 100 },
  ];
  defaultTrainer: Trainers = new Trainers();

  handleTrainerRowUpdate(update: TableRowUpdate): void {
    let item: Trainers = update.newRow as Trainers;
    this.transferHttp.put('Tr/SaveTrainer', item).subscribe(_ => {
      this.trainers = this.transferHttp.getHot(`Tr/GetTrainers`);
    });
  }

  handleTrainerRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: Trainers = deleted.row as Trainers;
    this.transferHttp.delete(`Tr/DeleteTrainer?trainerId=${deletedLineItem.trainerId}`).subscribe(_ => {
      this.trainers = this.transferHttp.getHot(`Tr/GetTrainers`);
    });
  }

  // Trainer to Qual Task Crossover
  trainerXQualTasksTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig, {
      create: false,
    });
  trainerXQualTasksTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualTaskId', label: 'For what Qualification Task', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualTaskId } },
  ];
  defaultQualTaskXTrainers: QualTaskXTrainers = new QualTaskXTrainers();;

  handleTrainerXQualTaskRowUpdate(update: TableRowUpdate): void {
    let item: QualTaskXTrainers = update.newRow as QualTaskXTrainers;
    this.transferHttp.put('Tr/SaveQualTaskTrainer', item).subscribe(_ => {
      this.trainers = this.transferHttp.getHot(`Tr/GetTrainers`);
      this.qualTaskTrainers = this.transferHttp.getHot(`Tr/GetQualTaskTrainers`);
    });
  }

  handleTrainerXQualTaskRowDelete(deleted: TableRowDelete) {
    const deletedLineItem: QualTaskXTrainers= deleted.row as QualTaskXTrainers;
    this.transferHttp.delete(`Tr/DeleteQualTaskTrainer?qualTaskTrainerId=${deletedLineItem.qualTaskTrainerId}`).subscribe(_ => {
      this.trainers = this.transferHttp.getHot(`Tr/GetTrainers`);
      this.qualTaskTrainers = this.transferHttp.getHot(`Tr/GetQualTaskTrainers`);
    });
  }

  // Qual Tasks X Trainers
  qualTaskXTrainerTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$ (
    this.permissions.ComponentID.TrainingConfig);
  qualTaskXTrainerTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'qualTaskId', label: 'For what Qual Task', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.qualTaskId } },
    { key: 'trainerId', label: 'Trainer', type: 'dynamic',  filterType: 'dynamic', validatorOrOpts: [Validators.required],
      events: { filterAndSortCompare: (term, el) => term === el.trainerId } },
  ];


  INDIVIDUALLY_ASSIGNED = 1;
  AIMS_NUMERIC_TYPES = AIMS_NUMERIC_TYPES;

  //***************************
  // Variables
  //***************************
  headerText: string = 'Training Config';

  user = this.transferHttp.getCache('user');
  empId = this.user.employeeId;

  allQualValues = [];
  allQualTaskValues = [];

  public getQualDescription(qualId: number): string {
    return this.allQualValues.filter(q => q.qualId == qualId).map(q => q.qualDesc)[0];
  }

  public getQualTaskDescription(qualTaskId: number): string {
    return this.allQualTaskValues.filter(qt => qt.qualTaskId == qualTaskId).map(qt => qt.qtDesc)[0];
  }

  //Grids
  quals = this.transferHttp.getHot(`Tr/GetQuals`);
  qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
  qualQualTasks = this.transferHttp.getHot(`Tr/GetQualQualTasks`);
  qualTaskPrerequisites = this.transferHttp.getHot(`Tr/GetQualTaskPrerequisites`);
  reqQualsForJobTitles = this.transferHttp.getHot(`Tr/GetReqQualsForJobTitles`);
  reqQualsForJobAssignments = this.transferHttp.getHot(`Tr/GetReqQualsForJobAssignments`);
  trainers = this.transferHttp.getHot(`Tr/GetTrainers`);
  qualTaskTrainers = this.transferHttp.getHot(`Tr/GetQualTaskTrainers`);
  reqQualsForEmps = this.transferHttp.getHot(`Tr/GetReqQualsForEmps`);
  reqQualsIndividaullyAssigned = this.transferHttp.getHot(`Tr/GetReqQualsIndividaullyAssigned`);

  showQualsGrid: boolean = false;
  newTrQual() {
    return new Quals();
  }

  showQualTasksGrid: boolean = false;
  newTrQualTask() {
    return new QualTasks();
  }

  showQualQualTasksGrid: boolean = false;
  newTrQualQualTask() {
    return new QualXQualTasks();
  }

  showQualTaskPrerequisitesGrid: boolean = false;
  newTrQualTaskPrerequisite() {
    return new QualTaskXPrerequisites();
  }

  showIndAssignedGrid: boolean = false;
  newTrReqQualForEmp() {
    return new QualXAssigned();
  }

  showReqJobTitlesGrid: boolean = false;
  newTrReqQualForJobTitle() {
    return new QualXJobTitles();
  }

  showReqJobAssignmentsGrid: boolean = false;
  newTrReqQualForJobAssignment() {
    return new QualXJobAssignments();
  }

  showTrainersGrid: boolean = false;
  newTrTrainer() {
    return new Trainers();
  }

  showQualTaskTrainersGrid: boolean = false;
  newTrQualTaskTrainer() {
    return new QualTaskXTrainers();
  }

  tableDropDownItems: Array<any> = [
    {
      text: 'Qualifications'
    }, {
      text: 'Qualification Tasks'
    }, {
      text: 'Qual - Qual Task, Crossover'
    }, {
      text: 'Qualification Task Prerequisites'
    }, {
      text: 'Individually Assigned Quals'
    }, {
      text: 'Job Title required Quals'
    }, {
      text: 'Employee Job Assignment required Quals'
    }, {
      text: 'Trainers'
    }, {
      text: 'Trainers for Qualification Task'
    }
  ];

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  //Used for aim-lookup
  qualificationLookupColumns:AimsCommonTableHeader[] = [
    { key: 'qualDesc', label: 'Qualification Description', type:AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'reqByAllEmps', label: 'Required By All Employees?',type:AimsCommonTableHeaderType.BOOLEAN, filter: true },
    { key: 'active', label: 'Active?',type:AimsCommonTableHeaderType.BOOLEAN, filter: true }
  ];

  qualificationTaskLookupColumns:AimsCommonTableHeader[] = [
    { key: 'qtDesc', label: 'Task Description',type:AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'interval', label: 'Interval In Months',type:AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'hazwoper', label: 'HAZWOPER?', type:AimsCommonTableHeaderType.BOOLEAN, filter: true },
    { key: 'active', label: 'Active?', type:AimsCommonTableHeaderType.BOOLEAN, filter: true }
  ];

  jobTitleLookupColumns:AimsCommonTableHeader[] = [
    { key: 'jobTitle', label: 'Job Title', type:AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'unionAffiliationCode', label: 'Union', type:AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'active', label: 'Active?',type:AimsCommonTableHeaderType.BOOLEAN, filter: true }
  ];

  jobAssignmentLookupColumns:AimsCommonTableHeader[] = [
    { key: 'assignmentDescription', label: 'Job Assignment', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'jobTitle', label: 'Job Title', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'active', label: 'Active?', type: AimsCommonTableHeaderType.BOOLEAN, filter: true }
  ];

  trainerLookupColumns:AimsCommonTableHeader[] = [
    { key: 'fullName', label: 'Trainer', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'active', label: 'Active?', type: AimsCommonTableHeaderType.BOOLEAN, filter: true }
  ];

  reqQualForEmpLookupColumns:AimsCommonTableHeader[] = [
    { key: 'fullName', label: 'Employee', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'jobTitle', label: 'Job Title', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'assignmentDescription', label: 'Job Assignment', type: AimsCommonTableHeaderType.STRING, filter: true }
  ];

  workSectionLookupColumns:AimsCommonTableHeader[] = [
    { key: 'workSection', label: 'Work Section', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filter: true },
  ];

  //Dropdowns/lookup
  activeEmployeeValues = this.transferHttp.getHot('Common/GetActiveEmployeesForDropDown');
  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);
  jobTitleValues = this.transferHttp.getHot(`Common/GetAllJobTitlesForDropdown`);
  jobAssignmentValues = this.transferHttp.getHot(`Common/GetAllEmployeeJobAssignmentsForDropdown`);
  workSectionValues = this.transferHttp.getHot('Common/GetAllWorksectionsForDropdown');

  trainerValues = this.transferHttp.getHot(`Tr/GetTrainers`);
  activeTrainerValues = this.transferHttp.getHot(`Tr/GetActiveTrainers`);
  qualValues = this.transferHttp.getHot(`Tr/GetQualsForDropDown`);
  qualValuesNotReqByAll = this.transferHttp.getHot(`Tr/GetQualsNotReqByAllForDropDown`);
  qualTaskValues = this.transferHttp.getHot(`Tr/GetQualTasksForDropDown`);

  trainingDetails = this.transferHttp.getHot(`Tr/GetEmpTrainingTasks`);

  employeePuValues = this.transferHttp.getHot(`Tr/GetActiveEmployeesForPopUp`);
  trainerPuValues = this.transferHttp.getHot(`Tr/GetTrainersForPopUp`);
  qualPuValues = this.transferHttp.getHot(`Tr/GetQualsForPopUp`);
  qualTaskPuValues = this.transferHttp.getHot(`Tr/GetQualTasksForPopUp`);

  jobTitlePuValues = this.transferHttp.getHot(`Hr/GetAllJobTitlesForPopUp`);
  jobAssignmentPuValues = this.transferHttp.getHot(`Hr/GetAllEmployeeJobAssignmentsForPopUp`);

  //New Popup
  newQualQualTask: QualXQualTasks = new QualXQualTasks;
  newQualTask: QualTasks = new QualTasks;
  newQualTaskPrerequisite: QualTaskXPrerequisites = new QualTaskXPrerequisites;
  newQualTaskTrainer: QualTaskXTrainers = new QualTaskXTrainers;
  newReqQualForJobTitle: QualXJobTitles = new QualXJobTitles;
  newReqQualForJobAssignment: QualXJobAssignments = new QualXJobAssignments;
  newReqQualForEmp: QualXAssigned = new QualXAssigned;

  //***************************
  // Functions
  //***************************

  getSelectedTable(event: any): void {
    this.headerText = 'Training Config-' + event.value;
    this.closeAllGrids();
    this.refreshAll();

    switch (event.value) {

      case 'Qualifications': {
        this.showQualsGrid = true;
        break;
      }
      case 'Qualification Tasks': {
        this.showQualTasksGrid = true;
        break;
      }
      case 'Qual - Qual Task, Crossover': {
        this.showQualQualTasksGrid = true;
        break;
      }
      case 'Qualification Task Prerequisites': {
        this.showQualTaskPrerequisitesGrid = true;
        break;
      }
      case 'Individually Assigned Quals': {
        this.showIndAssignedGrid = true;
        break;
      }
      case 'Job Title required Quals': {
        this.showReqJobTitlesGrid = true;
        break;
      }
      case 'Employee Job Assignment required Quals': {
        this.showReqJobAssignmentsGrid = true;
        break;
      }
      case 'Trainers': {
        this.showTrainersGrid = true;
        break;
      }
      case 'Trainers for Qualification Task': {
        this.showQualTaskTrainersGrid = true;
        break;
      }
    }
  }

  public refreshAll() {
    this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
    this.qualValues = this.transferHttp.getHot(`Tr/GetQualsForDropDown`);

    this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
    this.qualTaskValues = this.transferHttp.getHot(`Tr/GetQualTasksForDropDown`);

    this.qualQualTasks = this.transferHttp.getHot(`Tr/GetQualQualTasks`);
    this.qualTaskPrerequisites = this.transferHttp.getHot(`Tr/GetQualTaskPrerequisites`);
    this.reqQualsForJobTitles = this.transferHttp.getHot(`Tr/GetReqQualsForJobTitles`);
    this.reqQualsForJobAssignments = this.transferHttp.getHot(`Tr/GetReqQualsForJobAssignments`);
    this.trainers = this.transferHttp.getHot(`Tr/GetTrainers`);
    this.qualTaskTrainers = this.transferHttp.getHot(`Tr/GetQualTaskTrainers`);
    this.reqQualsForEmps = this.transferHttp.getHot(`Tr/GetReqQualsForEmps`);
    this.reqQualsIndividaullyAssigned = this.transferHttp.getHot(`Tr/GetReqQualsIndividaullyAssigned`);

    this.employeePuValues = this.transferHttp.getHot(`Tr/GetActiveEmployeesForPopUp`);
    this.trainerPuValues = this.transferHttp.getHot(`Tr/GetTrainersForPopUp`);
    this.qualPuValues = this.transferHttp.getHot(`Tr/GetQualsForPopUp`);
    this.qualTaskPuValues = this.transferHttp.getHot(`Tr/GetQualTasksForPopUp`);

    this.jobTitlePuValues = this.transferHttp.getHot(`Hr/GetAllJobTitlesForPopUp`);
    this.jobAssignmentPuValues = this.transferHttp.getHot(`Hr/GetAllEmployeeJobAssignmentsForPopUp`);

    this.qualValues.subscribe(data => { this.allQualValues = data; });
    this.qualTaskValues.subscribe(data => { this.allQualTaskValues = data; });
  }

  public closeAllGrids() {
    this.showQualsGrid = false;
    this.showQualTasksGrid = false;
    this.showQualQualTasksGrid = false;
    this.showQualTaskPrerequisitesGrid = false;
    this.showIndAssignedGrid = false;
    this.showReqJobTitlesGrid = false;
    this.showReqJobAssignmentsGrid = false;
    this.showTrainersGrid = false;
    this.showQualTaskTrainersGrid = false;
  }

  //QualQualTask -- crossover
  showNewQualQualTask: boolean = false;
  public addNewQualQualTaskPopUp(masterQual: Quals) {
    this.quals = this.transferHttp.getHot(`Tr/GetQuals`);

    this.newQualTask = new QualTasks;
    this.newQualQualTask = new QualXQualTasks;
    this.newQualQualTask.qualId = masterQual.qualId;
    this.showNewQualQualTask = true;
    let qualDesc = this.getQualDescription(this.newQualQualTask.qualId);

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      width: '500px',
      data: {
        header: `Link Qualification Task to: ' ${qualDesc}`,
        content: NewQualQualTaskDialogComponent,
        contentData: { qualTaskPuValues: this.qualTaskPuValues,
                       qualDesc: qualDesc,
                       qualificationTaskLookupColumns: this.qualificationTaskLookupColumns,
                       workSectionValues: this.workSectionValues
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.newQualQualTask.qualTaskId = dialogResult.qualTaskId;
        if (!this.newQualQualTask.qualTaskId) {
          this.newQualTask.qtDesc = dialogResult.qtDesc;
          this.newQualTask.intervalInMonths = dialogResult.intervalInMonths;
          this.newQualTask.qualTaskWsOwnerId = dialogResult.qualTaskWsOwnerId;
          this.newQualTask.hazwoper = dialogResult.hazwoper;
        }

        this.saveNewQualQualTask(this.newQualQualTask, this.newQualTask);
      }
      else {
        this.cancelNewQualQualTask();
      }
    });

  }

  public cancelNewQualQualTask() {
    this.newQualQualTask = new QualXQualTasks;
    this.showNewQualQualTask = false;
  }

  public saveNewQualQualTask(masterQualQualTask: QualXQualTasks, masterQualTask: QualTasks) {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    if (masterQualQualTask.qualTaskId == null || masterQualQualTask.qualTaskId == 0) {
      this.newQualTask = new QualTasks;

      this.newQualTask.qtDesc = masterQualTask.qtDesc;
      this.newQualTask.intervalInMonths = masterQualTask.intervalInMonths;
      this.newQualTask.qualTaskWsOwnerId = masterQualTask.qualTaskWsOwnerId;
      this.newQualTask.hazwoper = masterQualTask.hazwoper;

      this.transferHttp.put(`Tr/SaveQualTask`, this.newQualTask).subscribe(retVal => {
        this.showNewQualQualTask = false;
        this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
        this.qualTaskValues = this.transferHttp.getHot(`Tr/GetQualTasksForDropDown`);
        this.qualTaskPuValues = this.transferHttp.getHot(`Tr/GetQualTasksForPopUp`);

        if (retVal.Id != 0) {
          this.newQualQualTask.qualTaskId = retVal.id;

          this.transferHttp.put(`Tr/SaveQualQualTask`, this.newQualQualTask).subscribe(show => {
            this.showNewQualQualTask = false;
            this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
            this.showSpinner = false;
          });
        }
      });
    }
    else {
      this.newQualQualTask.qualTaskId = masterQualQualTask.qualTaskId;

      let linkExists = 0;
      this.qualQualTasks.subscribe(qqt => {
        linkExists = qqt.filter(b => b.qualId == this.newQualQualTask.qualId && b.qualTaskId == this.newQualQualTask.qualTaskId).length;
        if (linkExists > 0) {
          alert("That Link Already Exists!!! \n Cancelling Save.");
          this.showSpinner = false;
          return;
        }

        this.transferHttp.put(`Tr/SaveQualQualTask`, this.newQualQualTask).subscribe(show => {
          this.showNewQualQualTask = false;
          this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
          this.showSpinner = false;
        });
      })
    }
  }

  showNewReqQualForEmp: boolean = false;
  public addNewReqQualForEmpPopUp(masterQual: Quals) {
    this.quals = this.transferHttp.getHot(`Tr/GetQuals`);

    this.newReqQualForEmp = new QualXAssigned;
    this.newReqQualForEmp.qualId = masterQual.qualId;
    let qualDesc = this.getQualDescription(this.newReqQualForEmp.qualId);
    this.showNewReqQualForEmp = true;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      width: '400px',
      data: {
        header: 'Add Link to an Employee : ',
        content: NewReqQualForEmpDialogComponent,
        contentData: { employeePuValues: this.employeePuValues,
                       reqQualForEmpLookupColumns: this.reqQualForEmpLookupColumns,
                       qualDesc: qualDesc
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.newReqQualForEmp.employeeId = dialogResult.employeeId;

        this.saveNewReqQualForEmp(this.newReqQualForEmp);
      }
      else {
        this.cancelNewReqQualForEmp();
      }
    });
  }

  public addMultipleNewReqQualForEmpPopUp(masterQual: Quals) {
    this.quals = this.transferHttp.getHot(`Tr/GetQuals`);


    let qualDesc = this.getQualDescription(this.newReqQualForEmp.qualId);
    this.showNewReqQualForEmp = true;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      width: '460px',
      data: {
        header: 'Add Link to Employee(s) : ',
        content: NewReqQualForMultipleEmpsDialogComponent,
        contentData: { employeePuValues: this.employeePuValues,
                       reqQualForEmpLookupColumns: this.reqQualForEmpLookupColumns,
                       qualDesc: qualDesc
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        let newReqQualForEmps: Array<QualXAssigned> = new Array<QualXAssigned>();
        let empIds: Array<number> = dialogResult.employeeIds;
        empIds.forEach(element => {
          let newReqQualForEmp = new QualXAssigned();
          newReqQualForEmp.qualId = masterQual.qualId;
          newReqQualForEmp.employeeId = element;
          newReqQualForEmps.push(newReqQualForEmp);
        });

        this.saveNewReqQualForEmps(newReqQualForEmps);
      }
      else {
        this.cancelNewReqQualForEmp();
      }
    });
  }

  public cancelNewReqQualForEmp() {
    this.newReqQualForEmp = new QualXAssigned;
    this.showNewReqQualForEmp = false;
  }

  public saveNewReqQualForEmps(qualXEmps: Array<QualXAssigned>): void {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    this.reqQualsForEmps.subscribe(rqXe => {
      let newQualXEmps = qualXEmps.filter(b => !rqXe.find(x => b.employeeId == x.employeeId && b.qualId == x.qualId));

      this.transferHttp.put(`Tr/SaveReqQualForEmps`, newQualXEmps).subscribe(show => {
        this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
        this.showNewReqQualForEmp = false;
        this.showSpinner = false;
      });
    })
  }

  public saveNewReqQualForEmp(masterQualEmp: QualXAssigned) {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    this.newReqQualForEmp.employeeId = masterQualEmp.employeeId;

    let linkExists = 0;
    this.reqQualsForEmps.subscribe(rqXe => {
      linkExists = rqXe.filter(b => b.employeeId == this.newReqQualForEmp.employeeId && b.qualId == this.newReqQualForEmp.qualId).length;
      if (linkExists > 0) {
        alert("That Link Already Exists!!! \n Cancelling Save.");
        this.showSpinner = false;
        return;
      }

      this.transferHttp.put(`Tr/SaveReqQualForEmp`, this.newReqQualForEmp).subscribe({
        next: _ => {
          this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
          this.showNewReqQualForEmp = false;
          this.showSpinner = false;
        },
        error: _ => {
          this.showNewReqQualForEmp = false;
          this.showSpinner = false;
        }
      });
    })
  }

  //QualJobTitle -- crossover
  public addNewQualJobTitlePopUp(masterQual: Quals) {
    this.quals = this.transferHttp.getHot(`Tr/GetQuals`);

    this.newReqQualForJobTitle = new QualXJobTitles;
    this.newReqQualForJobTitle.qualId = masterQual.qualId;
    let qualDesc = this.getQualDescription(this.newReqQualForJobTitle.qualId);

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      width: '400px',
      data: {
        header: 'Add Link to a Job Title: ',
        content: NewQualJobTitleDialogComponent,
        contentData: { jobTitlePuValues: this.jobTitlePuValues,
                       jobTitleLookupColumns: this.jobTitleLookupColumns,
                       qualDesc: qualDesc
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.newReqQualForJobTitle.jobTitleId = dialogResult.jobTitleId;

        this.saveNewQualJobTitle(this.newReqQualForJobTitle);
      }
      else {
        this.cancelNewQualJobTitle();
      }
    });

  }

  public cancelNewQualJobTitle() {
    this.newReqQualForJobTitle = new QualXJobTitles;
  }

  public saveNewQualJobTitle(masterQualJobTitle: QualXJobTitles) {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    this.newReqQualForJobTitle.jobTitleId = masterQualJobTitle.jobTitleId;

    let linkExists = 0;
    this.reqQualsForJobTitles.subscribe(rqjt => {
      linkExists = rqjt.filter(b => b.jobTitleId == this.newReqQualForJobTitle.jobTitleId && b.qualId == this.newReqQualForJobTitle.qualId).length;
      if (linkExists > 0) {
        alert("That Link Already Exists!!! \n Cancelling Save.");
        this.showSpinner = false;
        return;
      }
      this.transferHttp.put(`Tr/SaveReqQualForJobTitle`, this.newReqQualForJobTitle).subscribe(show => {
        this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
        this.showSpinner = false;
      });
    })
  }

  //QualEmpJobAssignment -- crossover
  public addNewQualJobAssignmentPopUp(masterQual: Quals) {
    this.quals = this.transferHttp.getHot(`Tr/GetQuals`);

    this.newReqQualForJobAssignment = new QualXJobAssignments;
    this.newReqQualForJobAssignment.qualId = masterQual.qualId;
    let qualDesc = this.getQualDescription(this.newReqQualForJobAssignment.qualId);

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      width: '400px',
      data: {
        header: 'Add Link to a Job Assignment: ',
        content: NewQualJobAssignmentDialogComponent,
        contentData: { jobAssignmentPuValues: this.jobAssignmentPuValues,
                       jobAssignmentLookupColumns: this.jobAssignmentLookupColumns,
                       qualDesc: qualDesc
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.newReqQualForJobAssignment.employeeJobAssignmentId = dialogResult.employeeJobAssignmentId;

        this.saveNewQualJobAssignment(this.newReqQualForJobAssignment);
      }
      else {
        this.cancelNewQualJobAssignment();
      }
    });

  }

  public cancelNewQualJobAssignment() {
    this.newReqQualForJobAssignment = new QualXJobAssignments;
  }

  public saveNewQualJobAssignment(masterQualJobAssignment: QualXJobAssignments) {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    this.newReqQualForJobAssignment.employeeJobAssignmentId = masterQualJobAssignment.employeeJobAssignmentId;

    let linkExists = 0;
    this.reqQualsForJobAssignments.subscribe(rqja => {
      linkExists = rqja.filter(b => b.employeeJobAssignmentId == this.newReqQualForJobAssignment.employeeJobAssignmentId && b.qualId == this.newReqQualForJobAssignment.qualId).length;
      if (linkExists > 0) {
        alert("That Job Assignment Link Already Exists!!! \n Cancelling Save.");
        this.showSpinner = false;
        return;
      }

      this.transferHttp.put(`Tr/SaveReqQualForJobAssignment`, this.newReqQualForJobAssignment).subscribe(show => {
        this.quals = this.transferHttp.getHot(`Tr/GetQuals`);
        this.showSpinner = false;
      });
    })
  }

  //QualTaskQual -- crossover
  showNewQualTaskQual: boolean = false;
  public addNewQualTaskQualPopUp(masterQualTask: QualTasks) {
    this.quals = this.transferHttp.getHot(`Tr/GetQuals`);

    this.newQualQualTask = new QualXQualTasks;
    this.newQualQualTask.qualTaskId = masterQualTask.qualTaskId;
    let qualTaskDesc = this.getQualTaskDescription(this.newQualQualTask.qualTaskId);
    this.showNewQualTaskQual = true;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      width: '400px',
      data: {
        header: 'Add Link to a Qualification: ',
        content: NewQualTaskQualDialogComponent,
        contentData: { qualPuValues: this.qualPuValues,
                       qualificationLookupColumns: this.qualificationLookupColumns,
                       qualTaskDesc : qualTaskDesc
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.newQualQualTask.qualId = dialogResult.qualId;

        this.saveNewQualTaskQual(this.newQualQualTask);
      }
      else {
        this.cancelNewQualTaskQual();
      }
    });

  }

  public cancelNewQualTaskQual() {
    this.newQualQualTask = new QualXQualTasks;
    this.showNewQualTaskQual = false;
  }

  public saveNewQualTaskQual(masterQualTaskQual: QualXQualTasks) {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    this.newQualQualTask.qualId = masterQualTaskQual.qualId;

    let linkExists = 0;
    this.qualQualTasks.subscribe(qqts => {
      linkExists = qqts.filter(b => b.qualTaskId == this.newQualQualTask.qualTaskId && b.qualId == this.newQualQualTask.qualId).length;
      if (linkExists > 0) {
        alert("That Link Already Exists!!! \n Cancelling Save.");
        this.showSpinner = false;
        return;
      }

      this.transferHttp.put(`Tr/SaveQualQualTask`, this.newQualQualTask).subscribe(show => {
        this.showNewQualTaskQual = false;
        this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
        this.showSpinner = false;
      });
    })
  }

  //QualTaskPrerequisite -- crossover
  showNewQualTaskPrerequisite: boolean = false;
  public addNewQualTaskPrerequisitePopUp(masterQualTask: QualTasks) {
    this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);

    this.newQualTaskPrerequisite = new QualTaskXPrerequisites;
    this.newQualTaskPrerequisite.qualTaskId = masterQualTask.qualTaskId;
    let qualTaskDesc = this.getQualTaskDescription(this.newQualTaskPrerequisite.qualTaskId);
    this.showNewQualTaskPrerequisite = true;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      width: '400px',
      data: {
        header: 'Add Link to a Prerequisite Task: ',
        content: NewQualTaskPrerequisiteDialogComponent,
        contentData: { qualTaskPuValues: this.qualTaskPuValues,
                       qualificationTaskLookupColumns: this.qualificationTaskLookupColumns,
                       qualTaskDesc : qualTaskDesc
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.newQualTaskPrerequisite.preReqQualTaskId = dialogResult.preReqQualTaskId;

        this.saveNewQualTaskPrerequisite(this.newQualTaskPrerequisite);
      }
      else {
        this.cancelNewQualTaskPrerequisite();
      }
    });
  }

  public cancelNewQualTaskPrerequisite() {
    this.newQualTaskPrerequisite = new QualTaskXPrerequisites;
    this.showNewQualTaskPrerequisite = false;
  }

  public saveNewQualTaskPrerequisite(masterQualTaskPrerequisite: QualTaskXPrerequisites) {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    this.newQualTaskPrerequisite.preReqQualTaskId = masterQualTaskPrerequisite.preReqQualTaskId;

    let linkExists = 0;
    this.qualTaskPrerequisites.subscribe(qtps => {
      linkExists = qtps.filter(b => (b.qualTaskId = this.newQualTaskPrerequisite.qualTaskId && b.preReqQualTaskId == this.newQualTaskPrerequisite.preReqQualTaskId) ||
        (this.newQualTaskPrerequisite.qualTaskId == this.newQualTaskPrerequisite.preReqQualTaskId)).length;
      if (linkExists > 0) {
        alert("That Link Already Exists!!! \n Cancelling Save.");
        this.showSpinner = false;
        return;
      }

      this.transferHttp.put(`Tr/SaveQualTaskPrerequisite`, this.newQualTaskPrerequisite).subscribe(show => {
        this.showNewQualTaskPrerequisite = false;
        this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
        this.showSpinner = false;
      });
    })
  }

  //QualTaskTrainer -- crossover
  public addNewQualTaskTrainerPopUp(masterQualTaskTrainer: QualTasks) {
    this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);

    this.newQualTaskTrainer = new QualTaskXTrainers;
    this.newQualTaskTrainer.qualTaskId = masterQualTaskTrainer.qualTaskId;
    let qualTaskDesc = this.getQualTaskDescription(this.newQualTaskTrainer.qualTaskId);

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      width: '400px',
      data: {
        header: 'Add Link to a Trainer: ',
        content: NewQualTaskTrainerDialogComponent,
        contentData: { trainerPuValues: this.trainerPuValues,
                       trainerLookupColumns: this.trainerLookupColumns,
                       qualTaskDesc : qualTaskDesc
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.newQualTaskTrainer.trainerId = dialogResult.trainerId;

        this.saveNewQualTaskTrainer(this.newQualTaskTrainer);
      }
      else {
        this.cancelNewQualTaskTrainer();
      }
    });

  }

  public cancelNewQualTaskTrainer() {
    this.newQualTaskTrainer = new QualTaskXTrainers;
  }

  public saveNewQualTaskTrainer(masterQualTaskTrainer: QualTaskXTrainers) {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    this.newQualTaskTrainer.trainerId = masterQualTaskTrainer.trainerId;

    let linkExists = 0;
    this.qualTaskTrainers.subscribe(qtt => {
      linkExists = qtt.filter(b => b.qualTaskId == this.newQualTaskTrainer.qualTaskId && b.trainerId == this.newQualTaskTrainer.trainerId).length;
      if (linkExists > 0) {
        alert("That Link Already Exists!!! \n Cancelling Save.");
        this.showSpinner = false;
        return;
      }

      this.transferHttp.put(`Tr/SaveQualTaskTrainer`, this.newQualTaskTrainer).subscribe(show => {
        this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);
        this.showSpinner = false;
      });
    })
  }

  //TrainerQualTask -- crossover
  public addNewTrainerQualTaskPopUp(masterTrainer: Trainers) {
    this.qualTasks = this.transferHttp.getHot(`Tr/GetQualTasks`);

    this.newQualTaskTrainer = new QualTaskXTrainers;
    this.newQualTaskTrainer.trainerId = masterTrainer.trainerId;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      width: '400px',
      data: {
        header: 'Add Link to a Qual Task: ',
        content: NewTrainerQualTaskDialogComponent,
        contentData: { qualTaskPuValues: this.qualTaskPuValues,
                       qualificationTaskLookupColumns: this.qualificationTaskLookupColumns,
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.newQualTaskTrainer.qualTaskId = dialogResult.qualTaskId;

        this.saveNewTrainerQualTask(this.newQualTaskTrainer);
      }
      else {
        this.cancelNewTrainerQualTask();
      }
    });
  }

  public cancelNewTrainerQualTask() {
    this.newQualTaskTrainer = new QualTaskXTrainers;
  }

  public saveNewTrainerQualTask(masterQualTaskTrainer: QualTaskXTrainers) {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    this.newQualTaskTrainer.qualTaskId = masterQualTaskTrainer.qualTaskId;

    let linkExists = 0;
    this.qualTaskTrainers.subscribe(qtt => {
      linkExists = qtt.filter(b => b.qualTaskId == this.newQualTaskTrainer.qualTaskId && b.trainerId == this.newQualTaskTrainer.trainerId).length;
      if (linkExists > 0) {
        alert("That Link Already Exists!!! \n Cancelling Save.");
        this.showSpinner = false;
        return;
      }

      this.transferHttp.put(`Tr/SaveQualTaskTrainer`, this.newQualTaskTrainer).subscribe(show => {
        this.trainers = this.transferHttp.getHot(`Tr/GetTrainers`);
        this.showSpinner = false;
      });
    })
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
    this.qualValues.subscribe(data => { this.allQualValues = data; });
    this.qualTaskValues.subscribe(data => { this.allQualTaskValues = data; });
  };

}
